const SVG_NS = "http://www.w3.org/2000/svg";
const { time } = require("node:console");

var DEFAULTS = {
    inset: 48,          // breathing room at each end of the axis
    pillHeight: 26,
    pillGap: 8,         // minimum space between two pills
    pillMinWidth: 64,
    labelSize: 12,
    taskSize: 12,
    taskLeading: 20,
    taskWidth: 150,
    axisGap: 44,        // vertical distance from pill centre to axis
    stub: 18,           // stub line from axis down to first task
    spacing: "even",    // "even" | "date"
    opacity: { strong: 0.92, body: 0.66, mute: 0.42, hair: 0.18 }
};

const timeline = document.querySelector('.timeline');
const tlSVG = document.getElementById('devTimelineSVG');
const lineSeg = document.getElementById('tl-line-segment');
const progSeg = document.getElementById('tl-prog-seg');
const currentTick = document.getElementById('current-tick');
const timeMarkers = document.querySelectorAll('.t-markers');
const milestoneMarker = document.querySelectorAll('.milestone-marker');
const mmBorder = document.querySelectorAll('.mm-border-rect');
const descPointer = document.querySelectorAll('.desc-pointer');
const taskDesc = document.querySelectorAll('.task-desc');


const markerCount = timeMarkers.length;

function layoutTimeline() {
    const svgWidth = lineSeg ? lineSeg.getBoundingClientRect().width : 0;
    const span = svgWidth - DEFAULTS.inset * 2;
    const segWidth = markerCount > 1 ? span / (markerCount - 1) : 0;

    //Place circle once at start, once every "segWidth(px)", last one lands exactly at the end
    timeMarkers.forEach((marker, i) => {
        const cx = DEFAULTS.inset + i * segWidth;
        marker.setAttribute('cx', cx);
    });
    if(currentTick) {
        currentTick.setAttribute('r', 2.5);
        const curTick_Outer = document.createElementNS(SVG_NS, "circle");
        curTick_Outer.setAttribute('r', 6);
        curTick_Outer.setAttribute('fill', '#FFFFFF');
        curTick_Outer.setAttribute('stroke', '#13ce13');

        curTick_Outer.setAttribute('cx', currentTick.getAttribute('cx'));
        curTick_Outer.setAttribute('cy', currentTick.getAttribute('cy'));
        currentTick.parentNode.insertBefore(curTick_Outer, currentTick);
    }
    //Match progress line's end (x2) to current-tick marker's position
    if (progSeg && currentTick) {
        progSeg.setAttribute('x2', currentTick.getAttribute('cx'));
    }
    //Place milestone marker above timeMarker
    milestoneMarker.forEach((marker, i) => {
        const x = DEFAULTS.inset + i * segWidth;
        marker.setAttribute('x', x);
    });
    //Place txt pointer line below time marker
    descPointer.forEach((pointer, i) => {
        const x = DEFAULTS.inset + i * segWidth;
        pointer.setAttribute('x1', x);
        pointer.setAttribute('x2', x);

        if (i === 0) {
            pointer.style.stroke = '#13ce13';
            pointer.style.strokeOpacity = 1;
        }

    });

    //Center each task-desc block under its own marker, below the pointer line,
    //then clamp so edge items stay inside the SVG instead of overflowing.
    //Also measure each block's actual content height (it can vary/wrap), and
    //grow the SVG's own height to fit whichever block ends up tallest.
    let maxBottom = 0;
    taskDesc.forEach((fo, i) => {
        const cx = DEFAULTS.inset + i * segWidth;
        let x = cx - DEFAULTS.taskWidth / 2;
        x = Math.max(0, Math.min(x, svgWidth - DEFAULTS.taskWidth));
        fo.setAttribute('x', x);
        fo.setAttribute('width', DEFAULTS.taskWidth);

        const content = fo.querySelector('.task-desc-content');
        const contentHeight = content ? content.scrollHeight : 0;
        fo.setAttribute('height', contentHeight);

        const y = parseFloat(fo.getAttribute('y'));
        maxBottom = Math.max(maxBottom, y + contentHeight);
    });
    if (tlSVG && maxBottom > 0) {
        tlSVG.setAttribute('height', maxBottom + 16); // bottom breathing room
    }

    //Size + position the pill border rect around each milestone marker's text
    mmBorder.forEach((rect, i) => {
        const text = milestoneMarker[i];
        if (!text) return;

        const cx = DEFAULTS.inset + i * segWidth;
        const textY = parseFloat(text.getAttribute('y'));
        const textWidth = text.getBBox().width;
        const width = Math.max(DEFAULTS.pillMinWidth, textWidth + 32); // 16px padding each side
        const height = DEFAULTS.pillHeight;

        rect.setAttribute('x', cx - width / 2);
        rect.setAttribute('y', textY - height / 2);
        rect.setAttribute('width', width);
        rect.setAttribute('height', height);
        rect.setAttribute('rx', height / 2);
    });
}

layoutTimeline();

const timelineRO = new ResizeObserver(() => layoutTimeline());
if (timeline) timelineRO.observe(timeline);